import React from 'react';
import { mockNFTAssets } from '../mock';
import { Button } from '../components/ui/button';
import { ShoppingCart } from 'lucide-react';

const NFTAssets = () => {
  const getRarityColor = (rarity) => {
    switch (rarity) {
      case 'Legendary':
        return '#FFD700';
      case 'Epic':
        return '#9D4EDD';
      case 'Rare':
        return '#00FFD1';
      default:
        return '#FFFFFF';
    }
  };

  return (
    <section id="nfts" className="bg-black py-20">
      <div className="max-w-[1400px] mx-auto px-[7.6923%]">
        <div className="text-center mb-16">
          <h2 className="text-[48px] font-semibold leading-[1.1] tracking-[-0.02em] text-white mb-4">
            NFT Farm Assets
          </h2>
          <p className="text-[20px] font-medium leading-[1.5] text-[rgba(255,255,255,0.85)] max-w-2xl mx-auto">
            Own unique digital assets that generate real value
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {mockNFTAssets.map((asset) => (
            <div
              key={asset.id}
              className="border border-[rgba(255,255,255,0.25)] bg-[rgba(255,255,255,0.05)] hover:border-[#00FFD1] transition-all duration-400 overflow-hidden group"
            >
              <div className="h-56 overflow-hidden">
                <img
                  src={asset.image}
                  alt={asset.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-400"
                />
              </div>
              <div className="p-6">
                <div
                  className="inline-block px-3 py-1 text-xs font-semibold mb-3"
                  style={{
                    backgroundColor: `${getRarityColor(asset.rarity)}20`,
                    color: getRarityColor(asset.rarity),
                    border: `1px solid ${getRarityColor(asset.rarity)}40`
                  }}
                >
                  {asset.rarity}
                </div>
                <h3 className="text-[20px] font-semibold leading-[1.4] text-white mb-2">
                  {asset.name}
                </h3>
                <p className="text-[16px] font-normal leading-[1.4] text-[rgba(255,255,255,0.85)] mb-4">
                  {asset.description}
                </p>
                <div className="flex items-center justify-between">
                  <div>
                    <span className="text-[20px] font-semibold text-[#00FFD1] block">
                      {asset.price}
                    </span>
                    <span className="text-[14px] text-[#4D4D4D]">
                      {asset.priceUSD}
                    </span>
                  </div>
                  <Button className="bg-[rgba(255,255,255,0.1)] text-white hover:bg-[#00FFD1] hover:text-black border-0 rounded-none h-10 px-4 text-sm">
                    <ShoppingCart className="w-4 h-4" />
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Button className="bg-[#00FFD1] text-black hover:bg-[rgba(0,255,209,0.8)] border-0 rounded-none h-14 px-8 text-lg font-medium">
            Browse All NFTs
          </Button>
        </div>
      </div>
    </section>
  );
};

export default NFTAssets;
